import React,{useState} from 'react';
import EmployAside from "../aside";
import MesAchatsIndex from "./mes_achats";

const MesAchats = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    
    <div className="main-page-wrapper">
    <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar} />

    <MesAchatsIndex setIsOpenSidebar={setIsOpenSidebar} />
    </div>    
  );
};

export default MesAchats;
